module.exports = __webpack_public_path__ + "img/theme-day.adf0b4da.svg";